import { searchInitState, searchReducers } from "./reducer";
import { createSlice } from "@reduxjs/toolkit";

export const SLICE_NAME = "search";

export const searchState = createSlice({
  name: SLICE_NAME,
  initialState: searchInitState,
  reducers: searchReducers,
});

export const ACTIONS = searchState.actions;
export default searchState.reducer;
